import { useEffect } from 'react';
import { apiLoadingOverlay, apiLoadingOverlayEnd } from '../store/overlayloader/overlayLoadingSlice';



const useApiLoadingOverlay = (loadingStates, dispatch) => {
  // const memoizedLoadingStates = useMemo(() => loadingStates, [loadingStates]);

  useEffect(() => {
    if (loadingStates.some(isLoading => isLoading)) {
      dispatch(apiLoadingOverlay());
    } else {
      dispatch(apiLoadingOverlayEnd());
    }
  }, [loadingStates.some(isLoading => isLoading)]);
};

export default useApiLoadingOverlay;